import { useWaypoint } from '../WaypointProvider.jsx';
import { WaypointLink, formatDate, formatDays } from './bits.jsx';

export default function BatchView({ entity, tab }) {
  const { push } = useWaypoint();

  // GET /batches/:id stores the roster as a CSV in `userId` and its join
  // config (batch.joinconfig.js) replaces that with the student records
  // -- { id, name, email, phone } -- so that is where the list arrives.
  // `students` / `studentIds` are kept for endpoints that name it that way.
  const firstList = (...lists) => lists.find((l) => Array.isArray(l) && l.length) || [];
  const students = firstList(entity?.students, entity?.studentIds, entity?.userId);

  // Trainer arrives populated on some endpoints and as a bare id on
  // others. Either is enough to drill into.
  const trainer =
    entity?.trainer ||
    (Array.isArray(entity?.trainerId) ? entity.trainerId[0] : null) ||
    (entity?.trainerId && typeof entity.trainerId === 'object' ? entity.trainerId : null);
  const trainerId =
    trainer?.id || (typeof entity?.trainerId === 'string' ? entity.trainerId : null);
  const trainerName =
    trainer?.trainerName || trainer?.name || entity?.trainerName || null;

  if (tab === 'students') {
    if (students.length === 0) {
      return <p className="lp-muted">No students are on this batch yet.</p>;
    }

    return (
      <div className="lp-dialog-table">
        <table>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Student</th>
              <th>Email</th>
              <th>Phone</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {students.map((s, i) => (
              <tr key={s?.id || `${s?.name}-${i}`}>
                <td className="lp-num">{i + 1}</td>
                <td className="lp-name">{s?.name || 'Unnamed student'}</td>
                <td>{s?.email || '—'}</td>
                <td>{s?.phone || s?.mobile || '—'}</td>
                <td className="wp-rowact">
                  {/* Back out to a student from inside a batch. The
                      cycle student -> batch -> student is fine: each
                      push is its own frame, and back unwinds it. */}
                  {s?.id && (
                    <WaypointLink onClick={() => push('student', s.id)}>
                      Open
                    </WaypointLink>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <>
      <dl className="quiz-facts">
        <div>
          <dt>Course</dt>
          <dd>{entity?.courseName || entity?.course?.name || '—'}</dd>
        </div>
        <div>
          <dt>Trainer</dt>
          <dd>
            {trainerId && trainerName ? (
              <WaypointLink onClick={() => push('trainer', trainerId)}>
                {trainerName}
              </WaypointLink>
            ) : (
              trainerName || '—'
            )}
          </dd>
        </div>
        <div>
          <dt>Mode</dt>
          <dd>{entity?.mode || '—'}</dd>
        </div>
        <div>
          <dt>Days</dt>
          <dd>{formatDays(entity?.days)}</dd>
        </div>
        <div>
          <dt>Starts</dt>
          <dd>{formatDate(entity?.startTime || entity?.startDate)}</dd>
        </div>
        <div>
          <dt>Ends</dt>
          <dd>{formatDate(entity?.endTime || entity?.endDate)}</dd>
        </div>
        <div>
          <dt>Students</dt>
          <dd>{students.length || '—'}</dd>
        </div>
      </dl>

      {entity?.meetingLink && (
        <>
          <h5 className="pgm-section-title">Meeting</h5>
          <p className="ov-meeting">
            <a href={entity.meetingLink} target="_blank" rel="noreferrer noopener">
              Join the session
            </a>
            {entity.meetingId && (
              <span className="ov-meeting-id">ID {entity.meetingId}</span>
            )}
          </p>
        </>
      )}
    </>
  );
}
